import React, { Fragment } from 'react'
import { Intro, MultipleChoice } from 'cvs-core'

const data = {
  question:
    'Sarah wants to stop vaping but doesn’t know what resources are available to support her. As her friend, you want to help. What is an example of a resource you can recommend? Choose all that apply.',
  inputType: 'checkbox',
  options: [
    {
      label:
        'Utilize anonymous text message programs that provide a constant support network for quitting.',
    },
    {
      label:
        'Suggest she talk to her mom, counselor, or other trusted adult for help handling the situation.',
    },
    {
      label:
        'Download free apps that engage users quitting with tailored tips, inspiration, and challenges.',
    },
    {
      label:
        'Remain available as emotional support as she seeks professional help with her family doctor',
    },
  ],
}

const correctInput = {
  [data.question]: [
    data.options[0].label,
    data.options[1].label,
    data.options[2].label,
    data.options[3].label,
  ],
}

const feedback = {
  success: {
    title: 'Great job!',
    body: '',
  },
  error: {
    title: 'That’s incorrect.',
    body: '',
  },
  retry: {
    title: 'Not quite, give it another try',
    body: '',
  },
}

export default {
  title: 'Question 5',
  path: '/challenge/question-5',
  content: (
    <Fragment>
      <Intro
        title="Question 5"
        direction="Select all items that best answer the question."
      />
      <MultipleChoice
        data={data}
        correctInput={correctInput}
        feedback={feedback}
        score={10}
        partiallyCorrectScoring={true}
      />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Challenge/Question5.js